import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "avatar-dialog-content"
};
var _hoisted_2 = {
  class: "preview-avatar"
};
var _hoisted_3 = {
  class: "avatar-layer avatar-layer1"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "avatar-layer avatar-layer2"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "avatar-layer avatar-layer3"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  class: "avatar-tab"
};
var _hoisted_10 = {
  class: "avatar-content"
};
var _hoisted_11 = {
  key: 0,
  class: "avatar-group-title"
};
var _hoisted_12 = {
  class: "group-name"
};
var _hoisted_13 = {
  class: "group-hint"
};
var _hoisted_14 = {
  class: "avatar-list"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["src"];
var _hoisted_17 = ["onClick"];
var _hoisted_18 = {
  key: 0,
  class: "empty-box"
};
var _hoisted_19 = {
  class: "empty-text"
};
import { ref, watch, onMounted, reactive, computed } from 'vue';
import { LoadingPlugin, MessagePlugin } from 'tdesign-vue-next';
import { getStore } from "@/util/store";
import { getUserDecorationList, updateAvatar } from "../../api/user";
import GenerateImg from "./generateImg.vue";
export default {
  __name: 'avatarDialog',
  props: {
    avatarVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:avatarVisible', 'update'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var avatar = require('@/assets/defaultAvatar1.png');
    var props = __props;
    var activeAvatarRef = ref(null);
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo
    var visible = ref(props.avatarVisible);
    var emit = __emit;
    var activeTab = ref('avatarList');
    var activeAvatar = ref(0);
    var changeTab = function changeTab(tab) {
      activeTab.value = tab;
    };
    // 装饰数据列表
    var decorationData = reactive({
      avatarFrameList: [],
      avatarList: [],
      pendantList: []
    });

    // 当前选择的装饰-试穿
    var currentDecoration = reactive({
      avatarFrameList: null,
      avatarList: null,
      pendantList: null
    });
    //正式穿戴的数据
    var activeDecoration = reactive({
      avatarFrameList: null,
      avatarList: null,
      pendantList: null
    });
    var currentUrl = computed(function () {
      var avatar = decorationData.avatarList.find(function (item) {
        return item.exchangeId === currentDecoration.avatarList;
      });
      var avatarFrame = decorationData.avatarFrameList.find(function (item) {
        return item.exchangeId === currentDecoration.avatarFrameList;
      });
      var pendant = decorationData.pendantList.find(function (item) {
        return item.exchangeId === currentDecoration.pendantList;
      });
      return {
        avatar: avatar ? avatar.imgUrl : avatar,
        avatarFrame: avatarFrame ? avatarFrame.imgUrl : null,
        pendant: pendant ? pendant.imgUrl : null
      };
    });
    var activeUrl = computed(function () {
      var avatar = decorationData.avatarList.find(function (item) {
        return item.exchangeId === activeDecoration.avatarList;
      });
      var avatarFrame = decorationData.avatarFrameList.find(function (item) {
        return item.exchangeId === activeDecoration.avatarFrameList;
      });
      var pendant = decorationData.pendantList.find(function (item) {
        return item.exchangeId === activeDecoration.pendantList;
      });
      return {
        avatar: avatar ? avatar.imgUrl : avatar,
        avatarFrame: avatarFrame ? avatarFrame.imgUrl : null,
        pendant: pendant ? pendant.imgUrl : null
      };
    });
    var dataList = computed(function () {
      return decorationData[activeTab.value];
    });
    // 头像页按「经典 / 新版 / 我的」分段展示；头像框与饰品保持单段平铺
    // 依赖后端下发 avatarGroup 字段（NEW / CLASSIC；学生兑换的为 null）
    var AVATAR_SECTIONS = [{
      key: 'CLASSIC',
      title: '经典头像',
      hint: '陪伴过的老形象'
    }, {
      key: 'NEW',
      title: '新版头像',
      hint: '当前默认'
    }, {
      key: 'OWN',
      title: '我的头像',
      hint: '积分兑换'
    }];
    var renderSections = computed(function () {
      var list = decorationData[activeTab.value] || [];
      // 非头像页签：单段平铺
      if (activeTab.value !== 'avatarList') {
        return [{
          key: activeTab.value,
          title: '',
          hint: '',
          list: list
        }];
      }
      // 兜底：后端还没发版、拿不到 avatarGroup 时退化成单段，
      // 否则会把默认头像整批误标成「我的头像」
      if (!list.some(function (item) {
        return item.avatarGroup;
      })) {
        return [{
          key: 'ALL',
          title: '',
          hint: '',
          list: list
        }];
      }
      var sections = [];
      AVATAR_SECTIONS.forEach(function (section) {
        var items = list.filter(function (item) {
          var group = item.avatarGroup === 'CLASSIC' || item.avatarGroup === 'NEW' ? item.avatarGroup : 'OWN';
          return group === section.key;
        });
        if (items.length) {
          sections.push({
            key: section.key,
            title: section.title,
            hint: section.hint,
            list: items
          });
        }
      });
      return sections;
    });
    var currentActive = computed(function () {
      return currentDecoration[activeTab.value];
    });
    var changeAvatar = function changeAvatar(id) {
      currentDecoration[activeTab.value] = id;
    };
    var setAvatar = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var oldActiveId, fullAvatarUrl, instance, params, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              oldActiveId = Object.freeze(activeDecoration[activeTab.value]);
              activeDecoration[activeTab.value] = activeDecoration[activeTab.value] === id ? null : id;
              if (!activeDecoration[activeTab.value]) {
                changeAvatar(null);
              } else {
                changeAvatar(id);
              }
              _context.n = 1;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 100);
              });
            case 1:
              fullAvatarUrl = null;
              instance = LoadingPlugin({
                fullscreen: false,
                attach: '.avatar-dialog .t-dialog',
                text: '头像生成中...',
                preventScrollThrough: false
              });
              _context.p = 2;
              _context.n = 3;
              return activeAvatarRef.value.generateAvatar();
            case 3:
              fullAvatarUrl = _context.v;
              params = {
                avatarExchangeId: activeDecoration.avatarList,
                avatarFrameExchangeId: activeDecoration.avatarFrameList,
                pendantExchangeId: activeDecoration.pendantList,
                fullAvatarUrl: fullAvatarUrl
              };
              updateAvatar(params).then(function (res) {
                if (res.data.code === 0) {
                  // MessagePlugin.success('头像生成成功')
                  emit('update', fullAvatarUrl);
                  // closeDialog()
                }
                instance.hide();
              });
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.log(_t);
              instance.hide();
              activeDecoration[activeTab.value] = oldActiveId;
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4]]);
      }));
      return function setAvatar(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    /*const updateAvatar = (url) => {
      if (!url) return MessagePlugin.warning('请选择头像')
      emit('update', url)
      closeDialog()
    }*/

    var closeDialog = function closeDialog() {
      visible.value = false;
      emit('update:avatarVisible', false);
      emit('close');
    };
    var initData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, result, key, list, activeItem;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getUserDecorationList();
            case 1:
              res = _context2.v;
              console.log(res);
              if (res.data.code === 0) {
                result = res.data.data;
                Object.assign(decorationData, result);
                // 把正在使用的装饰设置到activeDecoration
                for (key in activeDecoration) {
                  list = decorationData[key];
                  if (list && list.length > 0) {
                    activeItem = list.find(function (item) {
                      return item.isSelect;
                    });
                    if (activeItem) {
                      activeDecoration[key] = activeItem.exchangeId;
                      currentDecoration[key] = activeItem.exchangeId;
                    }
                  }
                }
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function initData() {
        return _ref3.apply(this, arguments);
      };
    }();
    watch(function () {
      return props.avatarVisible;
    }, function (newValue) {
      console.log(newValue, 'newValue');
      visible.value = newValue;
    });
    onMounted(function () {
      initData();
    });
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        class: "avatar-dialog",
        header: "修改头像",
        visible: visible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return visible.value = $event;
        }),
        onClose: closeDialog,
        footer: null,
        width: "600px"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: currentUrl.value.avatar || _unref(avatar),
            alt: "",
            class: "layer-img"
          }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [currentUrl.value.avatarFrame ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: currentUrl.value.avatarFrame,
            alt: "",
            class: "layer-img"
          }, null, 8, _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [currentUrl.value.pendant ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: currentUrl.value.pendant,
            alt: "",
            class: "layer-img"
          }, null, 8, _hoisted_8)) : _createCommentVNode("", true)])]), _createVNode(GenerateImg, {
            "active-url": activeUrl.value,
            ref_key: "activeAvatarRef",
            ref: activeAvatarRef
          }, null, 8, ["active-url"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
            class: _normalizeClass(["avatar-tab-item", {
              active: activeTab.value === 'avatarList'
            }]),
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return changeTab('avatarList');
            })
          }, "头像", 2), _createElementVNode("div", {
            class: _normalizeClass(["avatar-tab-item", {
              active: activeTab.value === 'avatarFrameList'
            }]),
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return changeTab('avatarFrameList');
            })
          }, "头像框", 2), _createElementVNode("div", {
            class: _normalizeClass(["avatar-tab-item", {
              active: activeTab.value === 'pendantList'
            }]),
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return changeTab('pendantList');
            })
          }, "饰品", 2)]), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderSections.value, function (section) {
            return _openBlock(), _createElementBlock("div", {
              class: "avatar-group",
              key: section.key
            }, [section.title ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(section.title), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(section.hint), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.list, function (item) {
              return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["avatar-item", {
                  active: item.exchangeId === currentActive.value,
                  using: item.exchangeId === activeDecoration[activeTab.value]
                }]),
                key: item.exchangeId,
                onClick: function onClick($event) {
                  return changeAvatar(item.exchangeId);
                }
              }, [_createElementVNode("img", {
                src: item.imgUrl,
                alt: "",
                class: "avatar-img"
              }, null, 8, _hoisted_16), _createElementVNode("div", {
                class: "use-btn",
                onClick: _withModifiers(function ($event) {
                  return setAvatar(item.exchangeId);
                }, ["stop"])
              }, _toDisplayString(item.exchangeId === activeDecoration[activeTab.value] ? '卸下' : '佩戴'), 9, _hoisted_17)], 10, _hoisted_15);
            }), 128))])]);
          }), 128)), dataList.value && dataList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, "暂无" + _toDisplayString(activeTab.value === 'avatarFrameList' ? '头像框' : '饰品'), 1)])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};